import { useEffectFetchData } from '@hooks/useData';
import { getCategories } from '@lib/firestore/Category';

/**
 * Returns hook for fetching categories
 * @param id - Unique vehicle ID.
 */
export const useCategories = () => useEffectFetchData(getCategories);
